"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_OR_MASTER_RESOURCE_ID_PATTERN = void 0;
exports.CONTENT_OR_MASTER_RESOURCE_ID_PATTERN = /^rrn:([a-z0-9\-_]+)(:([a-z0-9\-_]+))?:([0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12})(:(([a-z]{2})-([A-Z]{2,3})))?$/; // tslint:disable-line max-line-length
//# sourceMappingURL=id.model.js.map